import React from 'react';
import AurBreadcrumb from '../../common/aur-breadcrumb/AurBreadCrumb';
import {t} from 'i18next';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import { EciHomePageTabs } from '../../../constants/constants';

const IndexOverview = () => {
  const breadCrumbItems = [
    {
      label: t('eca.ecaHomepage.coreEciHome'),
      path: `/eci-home-page?tab=${EciHomePageTabs.ECI_OVERVIEW}`,
    },
    {
      label: t('ecaIndexing.manageIndexes'),
    },
  ];
  const indexing = useSelector(
    (state: RootState) => state?.indexesBanner?.indexBannerData
  );
  return (
    <div>
      <div
        className={
          indexing?.showIndexBanner
            ? 'breadcrumb-section'
            : 'breadcrumb-index-section'
        }
      >
        <AurBreadcrumb items={breadCrumbItems} />
      </div>
    </div>
  );
};

export default IndexOverview;
